import capitalize from 'lodash/capitalize';
import flow from 'lodash/flow';
import kebabCase from 'lodash/kebabCase';

import { Pipe, PipeTransform } from '@angular/core';

import { join, map, split } from '@lib/utils';

@Pipe({ name: 'humanize' })
export class HumanizePipe implements PipeTransform {
  public transform = flow([
    kebabCase, split('-'), map(capitalize), join(' '),
  ]);
}